module.exports = __webpack_public_path__ + "static/guide_foldegardin.min-b07446c0b2f43a20876716411e14da9a.png";